export const RATIO_1_1 = '1:1';
export const RATIO_4_3 = '4:3';
export const RATIO_16_9 = '16:9';

export const WIDTH_200 = '200';
export const WIDTH_400 = '400';
export const WIDTH_800 = '800';
export const WIDTH_1600 = '1600';

// the aspect ration supported by our image service
export const ASPECT_RATIOS = {
  '1:1': {
    200: '200',
    400: '400',
    800: '800',
    1600: '1600',
  },
  '4:3': {
    400: '300',
    800: '600',
    1600: '1200',
  },
  '16:9': {
    400: '225',
    800: '450',
    1600: '900',
  },
};
